import { atom, createStore } from 'jotai'
import { Toast } from '../lib/toastsService'

export const toastsAtom = atom<Toast[]>([])

export const store = createStore()
